export const createSidebarSlice = (set, _get, _api) => ({
    collapsed: false,
    toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed })),
    setCollapsed(value) {
        if (typeof value !== 'boolean') {
            throw new TypeError('Invalid input: collapsed must be a boolean');
        }
        set({ collapsed: value });
    },
});
//# sourceMappingURL=sidebarSlice.js.map